import AbstractComponent from "./abstract-component";

export default class Dropdowns extends AbstractComponent {

    constructor(el) {
        super(el)
        this.selector = '[data-dropdown-toggle]'
        this.DOM = {};
        this.toggleFunction = this.toggle.bind(this)
        this.init();
    }

    init() {
        this.initDomElements();
        this.iniEvents();
    }

    initDomElements() {
        this.dropdowns = document.querySelectorAll(this.selector);
        this.dropdowns.forEach(dropdown => {
            const content = dropdown.querySelector('[data-dropdown-content]');
            if (dropdown.hasAttribute('opened') && content) {
                // Attendre que le DOM soit complètement rendu pour calculer la hauteur
                requestAnimationFrame(() => {
                    content.style.maxHeight = `${content.scrollHeight}px`;
                });
            }
        });
    }

    toggle(e) {
        const root = e.currentTarget.closest(this.selector) || e.target.closest(this.selector);
        if (!root) return;

        const wasOpen = root.hasAttribute('opened');
        const group = root.getAttribute('data-faq-group');

        // Si c'est un groupe FAQ, fermer tous les autres du même groupe
        if (group) {
            const groupItems = document.querySelectorAll(`[data-faq-group="${group}"]`);
            groupItems.forEach(item => {
                if (item !== root) {
                    item.removeAttribute('opened');
                    const otherContent = item.querySelector('[data-dropdown-content]');
                    const otherButton = item.querySelector('[aria-expanded]');
                    if (otherContent) {
                        otherContent.style.maxHeight = "";
                    }
                    if (otherButton) {
                        otherButton.setAttribute('aria-expanded', 'false');
                    }
                }
            });
        }

        // Toggle l'élément actuel
        if (wasOpen) {
            root.removeAttribute('opened');
        } else {
            root.setAttribute('opened', '');
        }

        const content = root.querySelector('[data-dropdown-content]');
        const button = root.querySelector('[aria-expanded]');
        
        if (content) {
            if (!wasOpen) {
                content.style.maxHeight = `${content.scrollHeight}px`;
                if (button) {
                    button.setAttribute('aria-expanded', 'true');
                }
            } else {
                content.style.maxHeight = "";
                if (button) {
                    button.setAttribute('aria-expanded', 'false');
                }
            }
        }
        setTimeout(() => this.app?.$scroll?.update?.(), 150);
    }

    setEvent(dropdown) {
        dropdown.addEventListener('click', this.toggleFunction);
    }

    removeEvent(dropdown) {
        dropdown.removeEventListener('click', this.toggleFunction);
    }

    iniEvents() {
        const items = Array.from(this.dropdowns || []);
        items.forEach((dropdown) => this.removeEvent(dropdown));
        this.dropdowns.forEach(dropdown => {
            this.removeEvent(dropdown);
            if (dropdown.getAttribute('data-dropdown-screen') == "mobile") {
                if (window.matchMedia('(max-width:1189.98px)').matches) {
                    this.setEvent(dropdown);
                }
            } else {
                this.setEvent(dropdown);
            }
        });
    }

    refresh() {
        this.initDomElements();
        this.iniEvents();
    }

    destroy() {
        this.dropdowns.forEach(dropdown => {
            this.removeEvent(dropdown);
        });
        this.dropdowns = [];
    }
}
